import { render, staticRenderFns } from "./inputinvoice.vue?vue&type=template&id=ca6e4508&scoped=true&"
import script from "./inputinvoice.vue?vue&type=script&lang=js&"
export * from "./inputinvoice.vue?vue&type=script&lang=js&"
import style1 from "./inputinvoice.vue?vue&type=style&index=1&id=ca6e4508&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6e4508",
  null
  
)

export default component.exports